var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex justify-space-around",attrs:{"elevation":"0","color":"transparent"}},_vm._l((_vm.items),function(item){return _c('v-btn',{key:item.title,attrs:{"link":"","to":item.path,"fab":"","elevation":"1","color":item.color}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(_vm._s(item.icon))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }